import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import { CustomModal } from "./CustomModal";
import { ModernButton } from "./DefaultImports";
function TermsAndConditions({
  showTermsAndConditions,
  setSetShowTermsAndConditions
}) {
  const {
    t
  } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    setShowModal(showTermsAndConditions);
  }, [showTermsAndConditions]);
  const closeModal = () => {
    setSetShowTermsAndConditions(false);
  };
  return <CustomModal show={showTermsAndConditions} onHide={closeModal} title={t("ui.components.termsAndConditions.acordoDosTermosECondicoes")} body={<div style={{
    maxHeight: "400px",
    overflowY: "auto"
  }}>
          <p>{t("ui.components.termsAndConditions.porFavorLeiaCuidadosamenteOsSeguintes")}</p>

          <h2>{t("ui.components.termsAndConditions.visaoGeral")}</h2>
          <p>{t("ui.components.termsAndConditions.text11AEmpresaSoupEsta")}</p>

          <h2>{t("ui.components.termsAndConditions.coletaEUsoDeDados")}</h2>
          <p>{t("ui.components.termsAndConditions.text21AEmpresaIraColetar")}</p>
          <p>{t("ui.components.termsAndConditions.text22OsDadosDoCliente")}</p>
          <p>{t("ui.components.termsAndConditions.text23AEmpresaUtilizaraOs")}</p>
          <p>{t("ui.components.termsAndConditions.text24ASoupPoderaUtilizar")}</p>

          <h2>{t("ui.components.termsAndConditions.segurancaDosDados")}</h2>
          <p>{t("ui.components.termsAndConditions.text31AEmpresaLevaA")}</p>
          <p>{t("ui.components.termsAndConditions.text32ASoupNaoVendera")}</p>
          <p>{t("ui.components.termsAndConditions.text33AEmpresaPoderaCompartilhar")}</p>

          <h2>{t("ui.components.termsAndConditions.retencaoDeDados")}</h2>
          <p>{t("ui.components.termsAndConditions.text41AEmpresaManteraOs")}</p>
          <p>{t("ui.components.termsAndConditions.text42AposOTerminoDa")}</p>

          <h2>{t("ui.components.termsAndConditions.conformidadeComAsLeis")}</h2>
          <p>{t("ui.components.termsAndConditions.text51ASoupCumpriraAs")}</p>
          <p>{t("ui.components.termsAndConditions.text52OClienteReconheceE")}</p>

          <h2>{t("ui.components.termsAndConditions.limitacaoDeResponsabilidade")}</h2>
          <p>{t("ui.components.termsAndConditions.text61AEmpresaNaoSera")}</p>

          <h2>{t("ui.components.termsAndConditions.modificacoesNoAcordo")}</h2>
          <p>{t("ui.components.termsAndConditions.text71ASoupReservaSe")}</p>

          <h2>{t("ui.components.termsAndConditions.informacoesDeContato")}</h2>
          <p>{t("ui.components.termsAndConditions.text81SeVoceTiverAlguma")}</p>

          <p>{t("ui.components.termsAndConditions.aoUtilizarNossosServicosVoceReconhece")}</p>
        </div>} footer={<ModernButton color="#ee754c" fontSize="14px" onClick={closeModal}>{t("ui.components.termsAndConditions.fechar")}</ModernButton>} />;
}
export default TermsAndConditions;
